import { MarkdownText } from 'components/MarkdownText'
import { ChatMessage } from 'types/chat-message'
import { AttachmentMessage, fromChatAttachment, fromUpload } from 'components/messages/AttachmentMessage'
import { Message, MessageContent, MessageFooter } from '@/components/ui/message'
import { Bubble, BubbleContent } from '@/components/ui/bubble'
import { formatISODate } from 'utils/dates'

export type UserTextMessageProps = {
  messageItem: ChatMessage
}
export const UserMessage = ({ messageItem }: UserTextMessageProps) => {
  const { message, createdAt } = messageItem

  return (
    <Message align="end">
      <MessageContent className="gap-0.5">
        {messageItem.operatorAttachments?.map((att) => (
          <AttachmentMessage attachment={fromUpload(att)} key={att._id} align={'right'} />
        ))}
        {messageItem.attachments?.map((att) => (
          <AttachmentMessage attachment={fromChatAttachment(att)} key={att._id} align={'right'} />
        ))}
        {!!message && (
          <>
            <Bubble align="end">
              <BubbleContent dir="auto">
                <MarkdownText text={message} />
              </BubbleContent>
            </Bubble>
            <MessageFooter>{formatISODate(createdAt)}</MessageFooter>
          </>
        )}
      </MessageContent>
    </Message>
  )
}
